import {
  EASYWAY_PERSONAL_ONLINE,
  EASYBIZ_CORPORATE_ONLINE,
  EASTWEST_CORPORATE,
  EASTWEST_PERSONAL_ONLINE,
  TRAVEL_MONEY_URL,
} from "utils/urls";
import { STORE_DIRECTORY, STORE_DIRECTORY_ATM } from "routes/paths";

export const LOCATION_POPUP_MENU = [
  {
    title: "EastWest ATMS",
    link: STORE_DIRECTORY_ATM,
    type: "Internal",
  },
  {
    title: "EastWest Stores",
    link: STORE_DIRECTORY,
    type: "Internal",
  },
];

export const ACCOUNT_LOGIN_POPUP_MENU = [
  {
    title:
      "<div style='display: flex; color: #542785''><div style='background: #B2006F; border-radius: 50%; height: 15px; width: 14px; display: flex; justify-content: center; align-items: center'><sup style='font-size: 6px;color: white'>NEW</sup></div>easy<span style='color: #B2006F; padding-right: 3px'>way</span>online - Personal</div>",
    link: EASYWAY_PERSONAL_ONLINE,
    type: "External",
    isNew: "New",
  },
  {
    title:
      "<div style='display: flex; color: #542785'><div style='background: #959e01; border-radius: 50%; height: 15px; width: 14px; display: flex; justify-content: center; align-items: center'><sup style='font-size: 6px; color: white'>NEW</sup></div>easy<span style='color: #959e01; padding-right: 3px'>biz</span>online - Corporate</div>",
    link: EASYBIZ_CORPORATE_ONLINE,
    type: "External",
    isNew: "New",
  },
  {
    title: "Travel Money",
    link: TRAVEL_MONEY_URL,
    type: "External",
  },
  {
    title: "EastWest Online - Personal",
    link: EASTWEST_PERSONAL_ONLINE,
    type: "External",
  },
  {
    title: "EastWest Online - Corporate",
    link: EASTWEST_CORPORATE,
    type: "External",
  }
];

export const ONLINE_BANKING_POPUP_MENU = [
  {
    title:
      "<div style='display: flex; color: #542785' onmouseover='this.style.color=#FFFFF'><div style='background: #B2006F; border-radius: 50%; height: 15px; width: 14px; display: flex; justify-content: center; align-items: center'><sup style='font-size: 6px;color: white'>NEW</sup></div>easy<span style='color: #B2006F; padding-right: 3px'>way</span>online - Personal</div>",
    link: EASYWAY_PERSONAL_ONLINE,
    type: "External",
    isNew: "New",
  },
  {
    title:
      "<div style='display: flex; color: #542785'><div style='background: #D5E14D; border-radius: 50%; height: 15px; width: 14px; display: flex; justify-content: center; align-items: center'><sup style='font-size: 6px'>NEW</sup></div>easy<span style='color: #D5E14D; padding-right: 3px'>biz</span>online - Corporate</div>",
    link: EASYBIZ_CORPORATE_ONLINE,
    type: "External",
    isNew: "New",
  },
  {
    title: "Travel Money",
    link: TRAVEL_MONEY_URL,
    type: "External",
  },
  {
    title: "EastWest Online - Personal",
    link: EASTWEST_PERSONAL_ONLINE,
    type: "External",
  },
  {
    title: "EastWest Online - Corporate",
    link: EASTWEST_CORPORATE,
    type: "External",
  }
];
